import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';

export const RadioButtonTitle = styled(Text).attrs({})`
  color: ${p =>
    p.hasError ? p.theme.colors.lightDanger : p.theme.colors.primaryText};
`;
